import billingCanonicalSql from "./sql/0001_billing_canonical.sql";
import billingSubjectBindingsSql from "./sql/0002_billing_subject_bindings.sql";
import billingSubjectFinalitySql from "./sql/0003_billing_subject_finality.sql";
import billingCustomerImportSql from "./sql/0004_billing_customer_import.sql";
import billingReconciliationObservabilitySql from "./sql/0005_billing_reconciliation_observability.sql";
import billingWebhookManagementSql from "./sql/0006_billing_webhook_management.sql";
import billingConnectionCredentialReferenceSql from "./sql/0007_billing_connection_credential_reference.sql";
import billingWebhookIngressObservabilitySql from "./sql/0008_billing_webhook_ingress_observability.sql";
import billingWebhookDeliveryHealthSql from "./sql/0009_billing_webhook_delivery_health.sql";
import billingCheckoutSessionsSql from "./sql/0010_billing_checkout_sessions.sql";
import billingSubjectBindingUniquenessSql from "./sql/0011_billing_subject_binding_uniqueness.sql";
import billingReconciliationLeaseEpochSql from "./sql/0012_billing_reconciliation_lease_epoch.sql";
import billingAuditFailureOutcomeSql from "./sql/0013_billing_audit_failure_outcome.sql";

export const EMBEDDED_BILLING_LEDGER = "athena_billing_migrations";

export const EMBEDDED_BILLING_MIGRATIONS = [
	{
		checksum: "billing-canonical-v1",
		filename: "0001_billing_canonical.sql",
		name: "billing_canonical",
		sql: billingCanonicalSql,
		version: 1,
	},
	{
		checksum: "billing-subject-bindings-v1",
		filename: "0002_billing_subject_bindings.sql",
		name: "billing_subject_bindings",
		sql: billingSubjectBindingsSql,
		version: 2,
	},
	{
		checksum: "billing-subject-finality-v2",
		filename: "0003_billing_subject_finality.sql",
		name: "billing_subject_finality",
		sql: billingSubjectFinalitySql,
		version: 3,
	},
	{
		checksum: "billing-customer-import-v1",
		filename: "0004_billing_customer_import.sql",
		name: "billing_customer_import",
		sql: billingCustomerImportSql,
		version: 4,
	},
	{
		checksum: "billing-reconciliation-observability-v1",
		filename: "0005_billing_reconciliation_observability.sql",
		name: "billing_reconciliation_observability",
		sql: billingReconciliationObservabilitySql,
		version: 5,
	},
	{
		checksum: "billing-webhook-management-v1",
		filename: "0006_billing_webhook_management.sql",
		name: "billing_webhook_management",
		sql: billingWebhookManagementSql,
		version: 6,
	},
	{
		checksum: "billing-connection-credential-reference-v1",
		filename: "0007_billing_connection_credential_reference.sql",
		name: "billing_connection_credential_reference",
		sql: billingConnectionCredentialReferenceSql,
		version: 7,
	},
	{
		checksum: "billing-webhook-ingress-observability-v1",
		filename: "0008_billing_webhook_ingress_observability.sql",
		name: "billing_webhook_ingress_observability",
		sql: billingWebhookIngressObservabilitySql,
		version: 8,
	},
	{
		checksum: "billing-webhook-delivery-health-v1",
		filename: "0009_billing_webhook_delivery_health.sql",
		name: "billing_webhook_delivery_health",
		sql: billingWebhookDeliveryHealthSql,
		version: 9,
	},
	{
		checksum: "billing-checkout-sessions-v1",
		filename: "0010_billing_checkout_sessions.sql",
		name: "billing_checkout_sessions",
		sql: billingCheckoutSessionsSql,
		version: 10,
	},
	{
		checksum: "billing-subject-binding-uniqueness-v1",
		filename: "0011_billing_subject_binding_uniqueness.sql",
		name: "billing_subject_binding_uniqueness",
		sql: billingSubjectBindingUniquenessSql,
		version: 11,
	},
	{
		checksum: "billing-reconciliation-lease-epoch-v1",
		filename: "0012_billing_reconciliation_lease_epoch.sql",
		name: "billing_reconciliation_lease_epoch",
		sql: billingReconciliationLeaseEpochSql,
		version: 12,
	},
	{
		checksum: "billing-audit-failure-outcome-v1",
		filename: "0013_billing_audit_failure_outcome.sql",
		name: "billing_audit_failure_outcome",
		sql: billingAuditFailureOutcomeSql,
		version: 13,
	},
] as const;

export const EMBEDDED_BILLING_REQUIRED_TABLES = [
	"billing_payments",
	"billing_subscriptions",
	"billing_invoices",
	"billing_subject_bindings",
	"billing_provider_connections",
	"billing_webhook_events",
	"billing_projection_events",
	"billing_import_state",
	"billing_import_runs",
	"billing_import_candidates",
	"billing_reconciliation_leases",
	"billing_webhook_registrations",
	"billing_webhook_ingress_stages",
	"billing_webhook_delivery_health",
	"billing_checkout_sessions",
] as const;

export const AUTH_UI_BILLING_PRESET_TABLES = [
	"billing_provider_connections",
	"billing_webhook_events",
	"billing_projection_events",
	"billing_import_runs",
	"billing_import_candidates",
	"billing_webhook_registrations",
] as const;
